@file:OptIn(InternalResourceApi::class)

package inspection.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/inspection.composeapp.generated.resources/"

@delegate:ResourceContentHash(217_699_896)
internal val Res.string.add_files: StringResource by lazy {
      StringResource("string:add_files", "add_files", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 33),
      ))
    }

@delegate:ResourceContentHash(2_081_151_583)
internal val Res.string.add_media: StringResource by lazy {
      StringResource("string:add_media", "add_media", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44, 29),
      ))
    }

@delegate:ResourceContentHash(-1_975_473_168)
internal val Res.string.all_done_your_inspection_has_been_successfully_submitted: StringResource by
    lazy {
      StringResource("string:all_done_your_inspection_has_been_successfully_submitted", "all_done_your_inspection_has_been_successfully_submitted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74, 140),
      ))
    }

@delegate:ResourceContentHash(970_169_788)
internal val Res.string.answer: StringResource by lazy {
      StringResource("string:answer", "answer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316, 22),
      ))
    }

@delegate:ResourceContentHash(-2_066_645_681)
internal val Res.string.answered_question: StringResource by lazy {
      StringResource("string:answered_question", "answered_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 266, 49),
      ))
    }

@delegate:ResourceContentHash(-2_066_645_589)
internal val Res.string.answered_questions: StringResource by lazy {
      StringResource("string:answered_questions", "answered_questions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215, 50),
      ))
    }

@delegate:ResourceContentHash(69_208_865)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 339, 32),
      ))
    }

@delegate:ResourceContentHash(38_267_618)
internal val Res.string.are_you_sure_want_to_delete_the_inspection: StringResource by lazy {
      StringResource("string:are_you_sure_want_to_delete_the_inspection", "are_you_sure_want_to_delete_the_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 372, 122),
      ))
    }

@delegate:ResourceContentHash(-987_083_397)
internal val Res.string.auditor: StringResource by lazy {
      StringResource("string:auditor", "auditor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 495, 27),
      ))
    }

@delegate:ResourceContentHash(691_855_911)
internal val Res.string.button_login_label: StringResource by lazy {
      StringResource("string:button_login_label", "button_login_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 523, 34),
      ))
    }

@delegate:ResourceContentHash(-1_320_945_082)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 558, 22),
      ))
    }

@delegate:ResourceContentHash(1_300_497_239)
internal val Res.string.category: StringResource by lazy {
      StringResource("string:category", "category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 581, 28),
      ))
    }

@delegate:ResourceContentHash(-355_864_792)
internal val Res.string.check: StringResource by lazy {
      StringResource("string:check", "check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 610, 21),
      ))
    }

@delegate:ResourceContentHash(2_034_802_711)
internal val Res.string.choose_template: StringResource by lazy {
      StringResource("string:choose_template", "choose_template", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 732, 43),
      ))
    }

@delegate:ResourceContentHash(-206_848_156)
internal val Res.string.choose_template_before_start_inspection: StringResource by lazy {
      StringResource("string:choose_template_before_start_inspection", "choose_template_before_start_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 632, 99),
      ))
    }

@delegate:ResourceContentHash(-390_049_422)
internal val Res.string.click_to_upload: StringResource by lazy {
      StringResource("string:click_to_upload", "click_to_upload", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 776, 43),
      ))
    }

@delegate:ResourceContentHash(-1_039_040_129)
internal val Res.string.complete: StringResource by lazy {
      StringResource("string:complete", "complete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 970, 28),
      ))
    }

@delegate:ResourceContentHash(724_940_252)
internal val Res.string.complete_inspection: StringResource by lazy {
      StringResource("string:complete_inspection", "complete_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 820, 55),
      ))
    }

@delegate:ResourceContentHash(775_946_559)
internal val Res.string.complete_remaining_item: StringResource by lazy {
      StringResource("string:complete_remaining_item", "complete_remaining_item", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 876, 63),
      ))
    }

@delegate:ResourceContentHash(-1_039_040_052)
internal val Res.string.completed: StringResource by lazy {
      StringResource("string:completed", "completed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 940, 29),
      ))
    }

@delegate:ResourceContentHash(-1_439_652_841)
internal val Res.string.conducted: StringResource by lazy {
      StringResource("string:conducted", "conducted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 999, 29),
      ))
    }

@delegate:ResourceContentHash(166_482_568)
internal val Res.string.confirm_approval: StringResource by lazy {
      StringResource("string:confirm_approval", "confirm_approval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1029, 48),
      ))
    }

@delegate:ResourceContentHash(-754_692_461)
internal val Res.string.confirm_logout_message: StringResource by lazy {
      StringResource("string:confirm_logout_message", "confirm_logout_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1078, 62),
      ))
    }

@delegate:ResourceContentHash(1_080_418_086)
internal val Res.string.confirm_logout_title: StringResource by lazy {
      StringResource("string:confirm_logout_title", "confirm_logout_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1141, 48),
      ))
    }

@delegate:ResourceContentHash(1_423_273_648)
internal val Res.string.confirm_qhse_approval: StringResource by lazy {
      StringResource("string:confirm_qhse_approval", "confirm_qhse_approval", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1190, 53),
      ))
    }

@delegate:ResourceContentHash(-1_860_859_617)
internal val Res.string.confirm_qhse_approved: StringResource by lazy {
      StringResource("string:confirm_qhse_approved", "confirm_qhse_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1244, 89),
      ))
    }

@delegate:ResourceContentHash(-1_456_893_983)
internal val Res.string.continue_inspection: StringResource by lazy {
      StringResource("string:continue_inspection", "continue_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1334, 55),
      ))
    }

@delegate:ResourceContentHash(-1_438_907_004)
internal val Res.string.continues: StringResource by lazy {
      StringResource("string:continues", "continues", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1390, 29),
      ))
    }

@delegate:ResourceContentHash(-419_695_352)
internal val Res.string.create_inspection: StringResource by lazy {
      StringResource("string:create_inspection", "create_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1420, 61),
      ))
    }

@delegate:ResourceContentHash(-1_959_108_374)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1532, 22),
      ))
    }

@delegate:ResourceContentHash(-2_140_525_286)
internal val Res.string.delete_inspection: StringResource by lazy {
      StringResource("string:delete_inspection", "delete_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1482, 49),
      ))
    }

@delegate:ResourceContentHash(1_408_052_214)
internal val Res.string.dismiss_snackbar: StringResource by lazy {
      StringResource("string:dismiss_snackbar", "dismiss_snackbar", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1555, 48),
      ))
    }

@delegate:ResourceContentHash(1_507_453_160)
internal val Res.string.done: StringResource by lazy {
      StringResource("string:done", "done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1604, 20),
      ))
    }

@delegate:ResourceContentHash(-738_475_599)
internal val Res.string.download_pdf: StringResource by lazy {
      StringResource("string:download_pdf", "download_pdf", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1625, 36),
      ))
    }

@delegate:ResourceContentHash(-375_745_964)
internal val Res.string.drag_photo: StringResource by lazy {
      StringResource("string:drag_photo", "drag_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1662, 54),
      ))
    }

@delegate:ResourceContentHash(-760_963_424)
internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1717, 20),
      ))
    }

@delegate:ResourceContentHash(-1_505_287_544)
internal val Res.string.empty_upload_message: StringResource by lazy {
      StringResource("string:empty_upload_message", "empty_upload_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1738, 72),
      ))
    }

@delegate:ResourceContentHash(756_381_579)
internal val Res.string.exit: StringResource by lazy {
      StringResource("string:exit", "exit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1859, 20),
      ))
    }

@delegate:ResourceContentHash(-1_632_047_870)
internal val Res.string.exit_inspection: StringResource by lazy {
      StringResource("string:exit_inspection", "exit_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1811, 47),
      ))
    }

@delegate:ResourceContentHash(762_539_465)
internal val Res.string.expand: StringResource by lazy {
      StringResource("string:expand", "expand", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1880, 22),
      ))
    }

@delegate:ResourceContentHash(-1_963_865_744)
internal val Res.string.files: StringResource by lazy {
      StringResource("string:files", "files", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1903, 21),
      ))
    }

@delegate:ResourceContentHash(16_670_203)
internal val Res.string.finding_category_description: StringResource by lazy {
      StringResource("string:finding_category_description", "finding_category_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1925, 112),
      ))
    }

@delegate:ResourceContentHash(-1_636_593_149)
internal val Res.string.findings: StringResource by lazy {
      StringResource("string:findings", "findings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2038, 28),
      ))
    }

@delegate:ResourceContentHash(-1_124_397_199)
internal val Res.string.flagged_items: StringResource by lazy {
      StringResource("string:flagged_items", "flagged_items", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2067, 41),
      ))
    }

@delegate:ResourceContentHash(1_353_986_162)
internal val Res.string.get_inspection: StringResource by lazy {
      StringResource("string:get_inspection", "get_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2109, 54),
      ))
    }

@delegate:ResourceContentHash(-1_792_547_391)
internal val Res.string.hide_password: StringResource by lazy {
      StringResource("string:hide_password", "hide_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2164, 41),
      ))
    }

@delegate:ResourceContentHash(-1_904_424_603)
internal val Res.string.icon_button: StringResource by lazy {
      StringResource("string:icon_button", "icon_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2206, 35),
      ))
    }

@delegate:ResourceContentHash(872_848_369)
internal val Res.string.icon_content_description: StringResource by lazy {
      StringResource("string:icon_content_description", "icon_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2242, 40),
      ))
    }

@delegate:ResourceContentHash(-353_744_625)
internal val Res.string.incomplete_inspection: StringResource by lazy {
      StringResource("string:incomplete_inspection", "incomplete_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2283, 57),
      ))
    }

@delegate:ResourceContentHash(-512_881_924)
internal val Res.string.initial_search_question: StringResource by lazy {
      StringResource("string:initial_search_question", "initial_search_question", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2341, 79),
      ))
    }

@delegate:ResourceContentHash(-769_481_165)
internal val Res.string.inspection: StringResource by lazy {
      StringResource("string:inspection", "inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2669, 34),
      ))
    }

@delegate:ResourceContentHash(484_313_659)
internal val Res.string.inspection_cannot_edit: StringResource by lazy {
      StringResource("string:inspection_cannot_edit", "inspection_cannot_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2421, 66),
      ))
    }

@delegate:ResourceContentHash(676_108_856)
internal val Res.string.inspection_completed: StringResource by lazy {
      StringResource("string:inspection_completed", "inspection_completed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2488, 64),
      ))
    }

@delegate:ResourceContentHash(-1_477_413_613)
internal val Res.string.inspection_progress: StringResource by lazy {
      StringResource("string:inspection_progress", "inspection_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2553, 115),
      ))
    }

@delegate:ResourceContentHash(467_242_426)
internal val Res.string.last_update: StringResource by lazy {
      StringResource("string:last_update", "last_update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2837, 35),
      ))
    }

@delegate:ResourceContentHash(1_166_774_578)
internal val Res.string.last_update_at: StringResource by lazy {
      StringResource("string:last_update_at", "last_update_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2704, 46),
      ))
    }

@delegate:ResourceContentHash(467_242_503)
internal val Res.string.last_updated: StringResource by lazy {
      StringResource("string:last_updated", "last_updated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2800, 36),
      ))
    }

@delegate:ResourceContentHash(-1_984_063_188)
internal val Res.string.last_updated_letter_case: StringResource by lazy {
      StringResource("string:last_updated_letter_case", "last_updated_letter_case", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2751, 48),
      ))
    }

@delegate:ResourceContentHash(1_329_454_287)
internal val Res.string.leading_icon_button: StringResource by lazy {
      StringResource("string:leading_icon_button", "leading_icon_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2873, 55),
      ))
    }

@delegate:ResourceContentHash(2_031_742_682)
internal val Res.string.location: StringResource by lazy {
      StringResource("string:location", "location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2929, 28),
      ))
    }

@delegate:ResourceContentHash(1_320_908_507)
internal val Res.string.login_splash: StringResource by lazy {
      StringResource("string:login_splash", "login_splash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2958, 36),
      ))
    }

@delegate:ResourceContentHash(201_756_828)
internal val Res.string.mark_as_officially_approved: StringResource by lazy {
      StringResource("string:mark_as_officially_approved", "mark_as_officially_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2995, 71),
      ))
    }

@delegate:ResourceContentHash(-688_945_106)
internal val Res.string.maximum_file: StringResource by lazy {
      StringResource("string:maximum_file", "maximum_file", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3067, 44),
      ))
    }

@delegate:ResourceContentHash(928_501_638)
internal val Res.string.maximum_photo: StringResource by lazy {
      StringResource("string:maximum_photo", "maximum_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3112, 49),
      ))
    }

@delegate:ResourceContentHash(1_628_943_374)
internal val Res.string.multiple_files_picker: StringResource by lazy {
      StringResource("string:multiple_files_picker", "multiple_files_picker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3162, 57),
      ))
    }

@delegate:ResourceContentHash(-1_581_186_788)
internal val Res.string.navigate_to: StringResource by lazy {
      StringResource("string:navigate_to", "navigate_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3220, 35),
      ))
    }

@delegate:ResourceContentHash(-267_214_431)
internal val Res.string.need_documentation: StringResource by lazy {
      StringResource("string:need_documentation", "need_documentation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3338, 50),
      ))
    }

@delegate:ResourceContentHash(2_140_531_799)
internal val Res.string.need_documentation_answer: StringResource by lazy {
      StringResource("string:need_documentation_answer", "need_documentation_answer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3256, 81),
      ))
    }

@delegate:ResourceContentHash(2_609_910)
internal val Res.string.new: StringResource by lazy {
      StringResource("string:new", "new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3432, 15),
      ))
    }

@delegate:ResourceContentHash(-399_898_842)
internal val Res.string.new_inspection: StringResource by lazy {
      StringResource("string:new_inspection", "new_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3389, 42),
      ))
    }

@delegate:ResourceContentHash(-37_059_791)
internal val Res.string.next_page: StringResource by lazy {
      StringResource("string:next_page", "next_page", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3448, 29),
      ))
    }

@delegate:ResourceContentHash(-110_314_801)
internal val Res.string.no_file_added: StringResource by lazy {
      StringResource("string:no_file_added", "no_file_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3478, 41),
      ))
    }

@delegate:ResourceContentHash(-1_567_289_072)
internal val Res.string.no_inspetions_scheduled: StringResource by lazy {
      StringResource("string:no_inspetions_scheduled", "no_inspetions_scheduled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3520, 63),
      ))
    }

@delegate:ResourceContentHash(-292_049_364)
internal val Res.string.no_photo_added: StringResource by lazy {
      StringResource("string:no_photo_added", "no_photo_added", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3584, 42),
      ))
    }

@delegate:ResourceContentHash(-1_077_830_073)
internal val Res.string.no_templates_found: StringResource by lazy {
      StringResource("string:no_templates_found", "no_templates_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3627, 50),
      ))
    }

@delegate:ResourceContentHash(137_058_803)
internal val Res.string.not_found: StringResource by lazy {
      StringResource("string:not_found", "not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3678, 29),
      ))
    }

@delegate:ResourceContentHash(-207_682)
internal val Res.string.notes: StringResource by lazy {
      StringResource("string:notes", "notes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3708, 21),
      ))
    }

@delegate:ResourceContentHash(101_070_127)
internal val Res.string.page_not_found: StringResource by lazy {
      StringResource("string:page_not_found", "page_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3730, 42),
      ))
    }

@delegate:ResourceContentHash(-1_488_328_888)
internal val Res.string.pages: StringResource by lazy {
      StringResource("string:pages", "pages", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3773, 21),
      ))
    }

@delegate:ResourceContentHash(-507_268_572)
internal val Res.string.photos: StringResource by lazy {
      StringResource("string:photos", "photos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3831, 22),
      ))
    }

@delegate:ResourceContentHash(-329_764_269)
internal val Res.string.photos_args: StringResource by lazy {
      StringResource("string:photos_args", "photos_args", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3795, 35),
      ))
    }

@delegate:ResourceContentHash(-1_470_561_105)
internal val Res.string.preview_template: StringResource by lazy {
      StringResource("string:preview_template", "preview_template", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3854, 48),
      ))
    }

@delegate:ResourceContentHash(-619_339_015)
internal val Res.string.previous_page: StringResource by lazy {
      StringResource("string:previous_page", "previous_page", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3903, 41),
      ))
    }

@delegate:ResourceContentHash(-159_255_878)
internal val Res.string.progress: StringResource by lazy {
      StringResource("string:progress", "progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3945, 28),
      ))
    }

@delegate:ResourceContentHash(1_293_511_808)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4016, 20),
      ))
    }

@delegate:ResourceContentHash(2_075_802_194)
internal val Res.string.save_progress: StringResource by lazy {
      StringResource("string:save_progress", "save_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3974, 41),
      ))
    }

@delegate:ResourceContentHash(1_801_743_962)
internal val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4194, 22),
      ))
    }

@delegate:ResourceContentHash(931_585_966)
internal val Res.string.search_no_result: StringResource by lazy {
      StringResource("string:search_no_result", "search_no_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4037, 52),
      ))
    }

@delegate:ResourceContentHash(-1_547_630_294)
internal val Res.string.search_result: StringResource by lazy {
      StringResource("string:search_result", "search_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4090, 53),
      ))
    }

@delegate:ResourceContentHash(-126_562_370)
internal val Res.string.search_this_audit: StringResource by lazy {
      StringResource("string:search_this_audit", "search_this_audit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4144, 49),
      ))
    }

@delegate:ResourceContentHash(-1_869_100_762)
internal val Res.string.select_category: StringResource by lazy {
      StringResource("string:select_category", "select_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4217, 43),
      ))
    }

@delegate:ResourceContentHash(-736_397_784)
internal val Res.string.select_location: StringResource by lazy {
      StringResource("string:select_location", "select_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4261, 43),
      ))
    }

@delegate:ResourceContentHash(280_690_581)
internal val Res.string.show_password: StringResource by lazy {
      StringResource("string:show_password", "show_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4305, 41),
      ))
    }

@delegate:ResourceContentHash(1_791_560_090)
internal val Res.string.start_inspection: StringResource by lazy {
      StringResource("string:start_inspection", "start_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4347, 48),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.status: StringResource by lazy {
      StringResource("string:status", "status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4396, 22),
      ))
    }

@delegate:ResourceContentHash(255_772_832)
internal val Res.string.submitting_inspection: StringResource by lazy {
      StringResource("string:submitting_inspection", "submitting_inspection", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4419, 65),
      ))
    }

@delegate:ResourceContentHash(-1_496_398_062)
internal val Res.string.supported_document_label: StringResource by lazy {
      StringResource("string:supported_document_label", "supported_document_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4485, 80),
      ))
    }

@delegate:ResourceContentHash(-2_109_201_087)
internal val Res.string.supported_image_label: StringResource by lazy {
      StringResource("string:supported_image_label", "supported_image_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4566, 65),
      ))
    }

@delegate:ResourceContentHash(-882_517_842)
internal val Res.string.template: StringResource by lazy {
      StringResource("string:template", "template", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4662, 28),
      ))
    }

@delegate:ResourceContentHash(-882_517_750)
internal val Res.string.templates: StringResource by lazy {
      StringResource("string:templates", "templates", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4632, 29),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_files", Res.string.add_files)
  map.put("add_media", Res.string.add_media)
  map.put("all_done_your_inspection_has_been_successfully_submitted", Res.string.all_done_your_inspection_has_been_successfully_submitted)
  map.put("answer", Res.string.answer)
  map.put("answered_question", Res.string.answered_question)
  map.put("answered_questions", Res.string.answered_questions)
  map.put("app_name", Res.string.app_name)
  map.put("are_you_sure_want_to_delete_the_inspection", Res.string.are_you_sure_want_to_delete_the_inspection)
  map.put("auditor", Res.string.auditor)
  map.put("button_login_label", Res.string.button_login_label)
  map.put("cancel", Res.string.cancel)
  map.put("category", Res.string.category)
  map.put("check", Res.string.check)
  map.put("choose_template", Res.string.choose_template)
  map.put("choose_template_before_start_inspection", Res.string.choose_template_before_start_inspection)
  map.put("click_to_upload", Res.string.click_to_upload)
  map.put("complete", Res.string.complete)
  map.put("complete_inspection", Res.string.complete_inspection)
  map.put("complete_remaining_item", Res.string.complete_remaining_item)
  map.put("completed", Res.string.completed)
  map.put("conducted", Res.string.conducted)
  map.put("confirm_approval", Res.string.confirm_approval)
  map.put("confirm_logout_message", Res.string.confirm_logout_message)
  map.put("confirm_logout_title", Res.string.confirm_logout_title)
  map.put("confirm_qhse_approval", Res.string.confirm_qhse_approval)
  map.put("confirm_qhse_approved", Res.string.confirm_qhse_approved)
  map.put("continue_inspection", Res.string.continue_inspection)
  map.put("continues", Res.string.continues)
  map.put("create_inspection", Res.string.create_inspection)
  map.put("delete", Res.string.delete)
  map.put("delete_inspection", Res.string.delete_inspection)
  map.put("dismiss_snackbar", Res.string.dismiss_snackbar)
  map.put("done", Res.string.done)
  map.put("download_pdf", Res.string.download_pdf)
  map.put("drag_photo", Res.string.drag_photo)
  map.put("edit", Res.string.edit)
  map.put("empty_upload_message", Res.string.empty_upload_message)
  map.put("exit", Res.string.exit)
  map.put("exit_inspection", Res.string.exit_inspection)
  map.put("expand", Res.string.expand)
  map.put("files", Res.string.files)
  map.put("finding_category_description", Res.string.finding_category_description)
  map.put("findings", Res.string.findings)
  map.put("flagged_items", Res.string.flagged_items)
  map.put("get_inspection", Res.string.get_inspection)
  map.put("hide_password", Res.string.hide_password)
  map.put("icon_button", Res.string.icon_button)
  map.put("icon_content_description", Res.string.icon_content_description)
  map.put("incomplete_inspection", Res.string.incomplete_inspection)
  map.put("initial_search_question", Res.string.initial_search_question)
  map.put("inspection", Res.string.inspection)
  map.put("inspection_cannot_edit", Res.string.inspection_cannot_edit)
  map.put("inspection_completed", Res.string.inspection_completed)
  map.put("inspection_progress", Res.string.inspection_progress)
  map.put("last_update", Res.string.last_update)
  map.put("last_update_at", Res.string.last_update_at)
  map.put("last_updated", Res.string.last_updated)
  map.put("last_updated_letter_case", Res.string.last_updated_letter_case)
  map.put("leading_icon_button", Res.string.leading_icon_button)
  map.put("location", Res.string.location)
  map.put("login_splash", Res.string.login_splash)
  map.put("mark_as_officially_approved", Res.string.mark_as_officially_approved)
  map.put("maximum_file", Res.string.maximum_file)
  map.put("maximum_photo", Res.string.maximum_photo)
  map.put("multiple_files_picker", Res.string.multiple_files_picker)
  map.put("navigate_to", Res.string.navigate_to)
  map.put("need_documentation", Res.string.need_documentation)
  map.put("need_documentation_answer", Res.string.need_documentation_answer)
  map.put("new", Res.string.new)
  map.put("new_inspection", Res.string.new_inspection)
  map.put("next_page", Res.string.next_page)
  map.put("no_file_added", Res.string.no_file_added)
  map.put("no_inspetions_scheduled", Res.string.no_inspetions_scheduled)
  map.put("no_photo_added", Res.string.no_photo_added)
  map.put("no_templates_found", Res.string.no_templates_found)
  map.put("not_found", Res.string.not_found)
  map.put("notes", Res.string.notes)
  map.put("page_not_found", Res.string.page_not_found)
  map.put("pages", Res.string.pages)
  map.put("photos", Res.string.photos)
  map.put("photos_args", Res.string.photos_args)
  map.put("preview_template", Res.string.preview_template)
  map.put("previous_page", Res.string.previous_page)
  map.put("progress", Res.string.progress)
  map.put("save", Res.string.save)
  map.put("save_progress", Res.string.save_progress)
  map.put("search", Res.string.search)
  map.put("search_no_result", Res.string.search_no_result)
  map.put("search_result", Res.string.search_result)
  map.put("search_this_audit", Res.string.search_this_audit)
  map.put("select_category", Res.string.select_category)
  map.put("select_location", Res.string.select_location)
  map.put("show_password", Res.string.show_password)
  map.put("start_inspection", Res.string.start_inspection)
  map.put("status", Res.string.status)
  map.put("submitting_inspection", Res.string.submitting_inspection)
  map.put("supported_document_label", Res.string.supported_document_label)
  map.put("supported_image_label", Res.string.supported_image_label)
  map.put("template", Res.string.template)
  map.put("templates", Res.string.templates)
}
